import type { AppConfig } from "./AppConfig";

const DARK_SCHEME = "(prefers-color-scheme: dark)";

const setLinkHref = (id: string, href: string) => {
  const link = document.getElementById(id) as HTMLLinkElement | null;
  if (link) link.href = href;
};

const applyDocumentBranding = (config: AppConfig) => {
  document.title = config.appName;
  const darkScheme = window.matchMedia(DARK_SCHEME);
  const applyFavicon = () =>
    setLinkHref(
      "app-favicon",
      darkScheme.matches ? config.faviconLightUrl : config.faviconUrl
    );
  applyFavicon();
  // Safari < 14 has only the legacy addListener; calling the missing
  // addEventListener there would throw before the app loads.
  if (typeof darkScheme.addEventListener === "function") {
    darkScheme.addEventListener("change", applyFavicon);
  } else {
    darkScheme.addListener(applyFavicon);
  }
  setLinkHref("app-touch-icon", config.faviconUrl);
};
export default applyDocumentBranding;
